import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../../vue";
import Markdown from '@tencent/ui-core/lib/builtin/components/Markdown';
import styles from "./Doc.style.module.css";
let DocItem = class DocItem extends Vue {
  render() {
    const h = arguments[0];
    const {
      doc
    } = this;
    const MDComp = Markdown;
    return h("div", {
      "class": styles.docItem
    }, [h("span", {
      "class": styles.docTitle
    }, [doc.title]), h(MDComp, {
      "attrs": {
        "source": doc.content
      }
    }), h("a-divider")]);
  }
};
__decorate([Prop()], DocItem.prototype, "doc", void 0);
DocItem = __decorate([Component({
  name: 'DocItem'
})], DocItem);
export default DocItem;
//# sourceMappingURL=DocItem.js.map
